"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.socketIncomingCommandAction = void 0;
const ActionTypes = require("../actionTypes/socket");
function socketIncomingCommandAction(payload) {
    return {
        type: ActionTypes.SOCKET_INCOMING_COMMAND,
        payload
    };
}
exports.socketIncomingCommandAction = socketIncomingCommandAction;
//# sourceMappingURL=socket.js.map